import { Fragment } from 'react';
import { SignalBadge } from '@/components';
import { RiskKeys } from '@/config';
import styles from './CategoriesValue.module.sass';

interface CategoriesValueProps {
  categories: RiskKeys[];
  emptyDisplay?: React.ReactNode;
}

export const CategoriesValue = ({
  categories,
  emptyDisplay = '—',
}: CategoriesValueProps) => {
  if (!categories?.length) {
    return <>{emptyDisplay}</>;
  }

  return (
    <div className={styles.list}>
      {categories.map((cat, i) => (
        <Fragment key={cat}>
          {i > 0 && ', '}
          <SignalBadge isTextOnly value={cat} />
        </Fragment>
      ))}
    </div>
  );
};
